import { aiAppRequest } from '@/utils/aiAppRequest'

export function getAiAppList(params, headers) {
  return aiAppRequest({
    url: '/ai_app/conversations',
    method: 'get',
    params,
    headers
  })
}
export function uploadFile(data, headers, onUploadProgress, cancelToken) {
  const formData = new FormData()
  // formData.append('file', file)
  // formData.append('user', user)
  for (const key in data) {
    formData.append(key, data[key])
  }
  console.log('formData', Object.assign({ 'Content-Type': 'multipart/form-data' }, headers))
  return aiAppRequest({
    url: '/ai_app/files/upload',
    method: 'post',
    data: formData,
    headers: Object.assign({ 'Content-Type': 'multipart/form-data' }, headers),
    onUploadProgress,
    cancelToken
  })
}

export function getGenerateChapters(data) {
  return aiAppRequest({
    url: '/ai_app/chat-messages',
    method: 'post',
    data
  })
}

export function stopGenerate(taskId, headers) {
  return aiAppRequest({
    url: '/ai_app/chat-messages/' + taskId + '/stop',
    method: 'post',
    headers
  })
}

export function updateAIChatHistory(conversationId, data, headers) {
  return aiAppRequest({
    url: `/ai_app/conversations/${conversationId}/name`,
    method: 'post',
    data,
    headers
  })
}

export function deleteAIChatHistory(conversationId, headers) {
  return aiAppRequest({
    url: `/ai_app/conversations/${conversationId}`,
    method: 'delete',
    headers
  })
}

// 文档分段查询
export function getDocumentSegments(path, params, headers) {
  return aiAppRequest({
    url: `/ai_app/datasets/${path.datasetId}/documents/${path.documentId}/segments`,
    method: 'get',
    headers,
    params
  })
}

// 获取文档嵌入进度
export function getDocumentEmbedProgress(params, headers) {
  return aiAppRequest({
    url: `/ai_app/datasets/${params.datasetId}/documents/${params.batch}/indexing-status`,
    method: 'get',
    headers
  })
}

// 获取源文档
export function getDocumentSource(params, headers) {
  return aiAppRequest({
    url: `/ai_app/datasets/${params.datasetId}/documents/${params.documentId}/upload-file`,
    method: 'get',
    headers
  })
}

// 更新文档分段
export function updateDocumentSegments(params, headers, data) {
  return aiAppRequest({
    url: `/ai_app/datasets/${params.datasetId}/documents/${params.documentId}/segments/${params.segmentId}`,
    method: 'post',
    data,
    headers
  })
}

// 删除文档分段
export function deleteDocumentSegments(params, headers) {
  return aiAppRequest({
    url: `/ai_app/datasets/${params.datasetId}/documents/${params.documentId}/segments/${params.segmentId}`,
    method: 'delete',
    headers
  })
}

// 详情
export function getAIChatHistoryDetail(params, headers) {
  return aiAppRequest({
    url: `/ai_app/messages`,
    method: 'get',
    params,
    headers
  })
}
